import React, {useEffect, useState} from "react";
import Header2 from "../../common/header/Header2";
import {Link, useLocation, useNavigate} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import {ReactComponent as NotificationIcon} from "../../pages/account/profile/profile_icon/notification-icon.svg";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../CryptoPage.css";
import Stack from "@mui/material/Stack";
import UserAvatar from "../userAvatar";
import "./subscription.css";
// import data from "./subsciption.json";
import GoogleLoginHandler from "../../common/hooks/GoogleLoginHandler";
import {BottomNavigation, BottomNavigationAction, IconButton, Box, Button, Typography} from "@mui/material";
import {tabLink} from "../../common/constant/tablink";
import {Tabs, Tab} from "@mui/material";
import {Helmet} from "react-helmet";
import LoginPopUp from "../../common/alert/login/LoginPopUp";
import WalletPayment from "./wallet_subscription/WalletPayment";
import {useAppKitProvider} from "@reown/appkit/react";

const Subscription = () => {
    const navigate = useNavigate();
    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );
    const mediaQueryVar2 = useMediaQuery(
        json2mq({
            maxWidth: 400,
        })
    );
    const [isLoginModalOpen, setLoginModalOpen] = React.useState(false);
    const [isLoggedIn, setIsLoggedIn] = React.useState(false);
    const location = useLocation();
    const loc = location.pathname;
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [selectedTab, setSelectedTab] = useState(mediaQueryVar ? "Invest" : "Portfolios");

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const payment = urlParams.get("payment");
        const priceId = "price_1QV4J8KAXtGoEI6mJntRzF1L";
        console.log("USer data", userData);
         if (userData && !("email_id" in userData)) { 
                setOpen(true);
            }
        else if (userData && payment === "true" && priceId) {
            const emailId = userData.email_id;
            handleCheckout(priceId, emailId);

            // Clean up URL to avoid re-triggering on refresh
            const newUrl = window.location.pathname;
            window.history.replaceState({}, "", newUrl);
        }
    }, []);

    const features = [
        {
            title: "INDEX",
            points: [
                "Track 50 Different Indices From\nInstitutions And VCs",
                "Instant Alerts On re-weighed Token\nIn Indices",
                "Instant Alerts On Addition Or Removal\nOf Tokens In Indices",
            ],
        },
        {
            title: "INFLUENCERS",
            points: [
                "Access To Latest Portfolios From\nBest Performing  X And YouTube\nCrypto Influencers",
                "Get First Access To Latest X\nInfluencers And YouTube Influencers\nPrice Predictions",
                "Get First Access To Top Rated X\nInfluencers And YouTube Influencers\nPortfolios And Recommendations",
            ],
        },
        {
            title: "SIGNALS",
            points: [
                "Know - Social Media, Whale,\nInfluencer Signals Change Instantly",
                "New Influencer Portfolios As They\nLaunch, New Price Predictions As They Launch",
                "Stay Informed On - Price Movements,\nIndices Change",
            ],
        },
        {
            title: (
                <>
                    RECOMMENDATIONS AND
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ALTERNATES
                </>
            ),
            points: [
                "Get Recommendations For Your\nUnder-performing Crypto",
                "Not Your Ordinary\nRecommendations-We Give You\nRecommendations Based On\nTechnical, Social, Retail And Whale\nTrends",
            ],
        },
    ];
    const featuresMobile = [
        {
            title: "INDEX",
            points: [
                "Track 50 Different Indices From\nInstitutions And VCs",
                "Instant Alerts On re-weighed\nToken In Indices",
                "Instant Alerts On Addition Or\nRemoval Of Tokens In Indices",
            ],
        },
        {
            title: "INFLUENCERS",
            points: [
                "Access To Latest Portfolios From\nBest Performing  X And YouTube\nCrypto Influencers",
                "Get First Access To Latest X\nInfluencers And YouTube Influencers\nPrice Predictions",
                "Get First Access To Top Rated X\nInfluencers And YouTube\nInfluencers Portfolios And\nRecommendations",
            ],
        },
        {
            title: "SIGNALS",
            points: [
                "Know - Social Media, Whale,\nInfluencer Signals Change\nInstantly",
                "New Influencer Portfolios As They\nLaunch, New Price Predictions As\nThey Launch",
                "Stay Informed On - Price\nMovements, Indices Change",
            ],
        },
        {
            title: (
                <>
                    RECOMMENDATIONS AND
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ALTERNATES
                </>
            ),
            points: [
                "Get Recommendations For Your\nUnder-performing Crypto",
                "Not Your Ordinary\nRecommendations-We Give You\nRecommendations Based On\nTechnical, Social, Retail And\nWhale Trends",
            ],
        },
    ];

    const getLinkFromTitle = (title) => {
        const normalizedTitle =
            typeof title === "string" ? title : React.Children.toArray(title).join("").replace(/\s+/g, " ").trim();
        switch (normalizedTitle) {
            case "INDEX":
                return "/indices";
            case "INFLUENCERS":
                return "/top-portfolios";
            case "SIGNALS":
                return "/premium-alerts";
            default:
                return "/audit-my-portfolio";
        }
    };

    const handleBackClick = () => {
        navigate(-1);
    };
    const handleModalClose = () => {
        setLoginModalOpen(false);
        navigate(location.pathname, {replace: true});
    };
    const handleCheckout = async (price_id, email) => {
        try {
            const response = await fetch("https://investing.crowdwisdom.live/create-checkout-session", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({price_id, email}),
            });

            const session = await response.json();

            if (session.error) {
                console.error("Server Error: ", session.error);
                alert(`Error: ${session.error}`);
                return;
            }

            if (session.url) {
                window.location.href = session.url;
            }
        } catch (error) {
            console.error("Error during checkout: ", error);
        }
    };

    useEffect(() => {
        setIsLoggedIn(userData ? true : false);
    }, []);

    const stripePriceId = {
        plan_2: "price_1QwbqlKAXtGoEI6mmRIKdGnh",
        plan_3: "price_1QwbrDKAXtGoEI6mlEMXFJWd",
    };

    const [open, setOpen] = useState(false);
    const [unreadAlerts, setUnreadAlerts] = useState(0);

    useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlertsCount = async () => {
            try {
                const formData = new URLSearchParams();
                formData.append("user_id", userId); // convert to form-encoded format

                const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/crypto_alerts_count", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded", // ✅ no preflight
                    },
                    body: formData, // ✅ correct format for this content type
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                const data = await response.json();
                setUnreadAlerts(data.unread_notifications);
            } catch (error) {
                console.error("Failed to fetch alerts:", error);
            }
        };

        fetchAlertsCount();
    }, []);

    const drawerWidth = 292;
    const handleLoginClick = () => {
        if (!userData) {
            const originalUrl = "/subscriptions";
            sessionStorage.setItem("originalUrl", originalUrl);
           
            window.history.pushState({}, "", "/login");
            localStorage.setItem("isPopupManuallyOpened", "true");
            setLoginModalOpen(true);
        }
    };
    

    const [path, setPath] = useState("/");
    const [mobileOpen, setMobileOpen] = React.useState(false);

    useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, []);

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "6px 13px" : "2px 13px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "16px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                        }}
                    >
                        {[tabLink["subscription"], tabLink["influencer_ranking_prediction"], tabLink["screener"]].map(
                            (tab, index) => (
                                <Link to={tab.href} style={{textDecoration: "none", minWidth: "130px"}}>
                                    <div style={topTabStyle(isActive(tab.href))}>
                                        <img
                                            src={window.constants.asset_path + tab.icon}
                                            alt="home"
                                            style={{
                                                marginRight: "6px",
                                                filter: iconFilter(isActive(tab.href)),
                                                width: tab.icon_width || "25px",
                                            }}
                                        />
                                        {!mediaQueryVar ? tab.mobile_name : tab.name}
                                    </div>
                                </Link>
                            )
                        )}
                    </div>

                    {/* Notification Bell */}
                    <div style={{display:"flex",alignItems:"center", justifyContent:"flex-end",gap:"5px",marginRight:"15px"}}>

                    {/* Notification Bell */}
                    <div
                        onClick={() => (window.location.href = "/alerts")}
                        style={{position: "relative", cursor: "pointer"}}
                    >
                        <NotificationIcon className="notification-icon fa-2x" />
                        {/* Desktop */}
                        <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px": "27px",
                                    height: unreadAlerts < 100 ? "20px": "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                                >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                                </div>
                    </div>

                     <UserAvatar/>
            </div>
                </div>

                {/* Bottom Tabs */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "60px",
                        marginTop: "40px",
                    }}
                >
                    {[
                        {
                            icon: window.constants.asset_path + "/images/profile_image/account_image/invest-icon.svg",
                            label: "Presale",
                            href: "/pre-sale",
                        },
                        {
                            icon: window.constants.asset_path + "/images/portfolio_tab.svg",
                            label: userData ? "My Portfolios" : "Portfolio Audit",
                            href: userData ? "/my-portfolio" : "/audit-my-portfolio",
                        },
                        {
                            icon: window.constants.asset_path + "/images/profile_tab.svg",
                            label: "My Profile",
                            href: "/account",
                        },
                    ].map((tab, i) => {
                        const isProfileTab = tab.label === "My Profile";

                        const handleClick = (e) => {
                            if (isProfileTab && !userData) {
                                e.preventDefault(); // Prevent navigation
                                handleLoginClick();
                            }
                        };

                        return (
                            <Link to={tab.href} key={i} style={{textDecoration: "none"}} onClick={handleClick}>
                                {" "}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "10px 20px",
                                        borderRadius: "28px",
                                        background:
                                            "var(--linek, linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%))",
                                        color: "#1877F2",
                                        fontWeight: "700",
                                        border: "1px solid #1877F2",
                                        fontSize: "16px",
                                        cursor: "pointer",
                                        justifyContent: "center",
                                        minWidth: "130px",
                                    }}
                                >
                                    <img src={tab.icon} alt="icon" style={{marginRight: "8px", height: "20px"}} />
                                    {tab.label}
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        );
    };

    const bottomNavigationMobile = [
        tabLink["presale"],
        userData ? tabLink["my_portfolio"] : tabLink["portfolio_audit"],
        tabLink["profile"],
    ];

    const topNavigationMobile = [tabLink["subscription"], tabLink["influencer_ranking_prediction"]];
    const onSelectAmount = (price_id) => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        
        if (!userData) {
            const originalUrl = "/subscriptions/?payment=true";
            sessionStorage.setItem("originalUrl", originalUrl);
            window.history.pushState({}, "", "/login");
            localStorage.setItem("isPopupManuallyOpened", "true");

            // Open the login modal
            setLoginModalOpen(true);

            return;
        } else {
            const originalUrl = "/subscriptions";
            sessionStorage.setItem("originalUrl", originalUrl);
            window.history.pushState({}, "", "/login");
            localStorage.setItem("isPopupManuallyOpened", "true");

            console.log("userData testing",  ("email_id" in userData));
            if (userData && !("email_id" in userData)) { 
                setOpen(true);
            } else {
                setOpen(false);
                // const userData_full = JSON.parse(userData);

                // Access the email_id
                const emailId = userData.email_id;

                handleCheckout(price_id, emailId); // Call handleCheckout with the selected amount
            }
        }
    };


    const handleClose = () => {
        console.log("setOpen(false);", open);
        setOpen(false);
    };

    return (
        <div className="d-flex row  w-100 m-0">
            <Helmet>
                <title>Subscriptions</title>
            </Helmet>
            {mediaQueryVar && (
                <Header2>
                    {/* <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0, // aligns it to the right of the sidebar
                        width: "100%", // takes full width minus sidebar
                        backgroundColor: "#ffffff",
                        zIndex: 1000,
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        height: "100px",
                        padding: "10px",
                    }}
                >
                    <TopNavigationMobile unreadAlerts={unreadAlerts} />
                </div> */}
                </Header2>
            )}
            {mediaQueryVar === false && (
                <div style={{display: "flex", justifyContent: "flex-end"}}>
                    <Header2
                        bottomNavigationMobile={bottomNavigationMobile}
                        topNavigationMobile={topNavigationMobile}
                    />
                </div>
            )}
            {mediaQueryVar && (
                <div className="content">
                    {/* Top Section: Tabs + My Profile Button + Notification */}
                    <Box sx={{marginTop: "2%"}}>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{marginTop: "70px", marginBottom: "100px"}}
                        >
                            {/* Tabs with My Profile as the first Tab */}
                            <Box
                                sx={{
                                    background: "linear-gradient(90deg, #1877F2 0%, #1877F2 100%)",
                                    borderRadius: "50px",
                                    display: "flex",
                                    padding: "4px",
                                    minHeight: "48px",
                                    alignItems: "center",
                                    minWidth: "60%",
                                    overflow: "hidden",
                                }}
                            >
                                <Tabs
                                    value={selectedTab}
                                    onChange={(e, newValue) => {
                                        if (newValue === "MyProfile") {
                                            navigate("/top-portfolios");
                                        } else if (newValue === "Farm") {
                                            navigate("/reward-section");
                                        }
                                        setSelectedTab(newValue);
                                    }}
                                    variant="fullWidth"
                                    sx={{
                                        width: "100%",
                                        minHeight: "40px",
                                        "& .MuiTabs-flexContainer": {
                                            gap: "4px", // Use spacing here instead of mx on Tabs
                                        },
                                        "& .MuiTabs-indicator": {display: "none"},
                                    }}
                                >
                                    {[
                                        {label: "Top Portfolio", value: "MyProfile"},
                                        {label: "Subscription Plan", value: "Invest"},
                                        {label: "Farm $WISD", value: "Farm"},
                                    ].map((tab) => (
                                        <Tab
                                            key={tab.value}
                                            icon={
                                                <Box
                                                    component="img"
                                                    src={
                                                        tab.value === "MyProfile"
                                                            ? "/images/white-suitcase.svg"
                                                            : tab.value === "Invest"
                                                            ? "/images/rounded-dollar.svg"
                                                            : "/images/search-new.svg"
                                                    }
                                                    alt={tab.label}
                                                    sx={{
                                                        width: tab.value === "Farm" ? "20.868px" : "30px",
                                                        height: tab.value === "Farm" ? "20.872px" : "30px",
                                                    }}
                                                />
                                            }
                                            iconPosition="start"
                                            label={tab.label}
                                            value={tab.value}
                                            sx={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                backgroundColor: selectedTab === tab.value ? "#fff" : "transparent",
                                                color: selectedTab === tab.value ? "#000 !important" : "#fff",
                                                borderRadius: "50px",
                                                px: 2,
                                                py: 0.3,
                                                mx: "2px",
                                                lineHeight: "36px",
                                                fontSize: selectedTab === tab.value ? "17px" : "16px",
                                                fontWeight: 400,
                                                minHeight: "36px",
                                                minWidth: "fit-content",
                                                textTransform: "none",
                                            }}
                                        />
                                    ))}
                                </Tabs>
                            </Box>

                            <Button
                                onClick={() => navigate("/account")}
                                sx={{
                                    ml: 2,
                                    mt: {xs: 2, sm: 0},
                                    background: "linear-gradient(90deg, #C1F5FF 0%, #FFF9C4 100%)",
                                    borderRadius: "50px",
                                    color: "#1877F2",
                                    fontWeight: "400",
                                    fontSize: "16px",
                                    padding: "6px 16px",
                                    textTransform: "none",
                                    whiteSpace: "nowrap",
                                    border: "1px solid #1877F2",
                                    boxShadow:
                                        "0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                    "&:hover": {
                                        background:
                                            "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
                                    },
                                    width: "160px",
                                }}
                            >
                                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                                    <Box component="img" src="/images/avatar-new.svg" sx={{width: 25, height: 25}} />
                                    <span>My Profile</span>
                                </Stack>
                            </Button>

                            {/* Notification + Profile */}
                            <Box display="flex" alignItems="center" gap={2}>
                                <Box
                                    className="notification-section"
                                    position="relative"
                                    onClick={() => navigate("/alerts")}
                                    sx={{cursor: "pointer"}}
                                >
                                    <NotificationIcon fontSize="large" sx={{color: "#1877F2"}} />
                                    {unreadAlerts > 0 && (
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                top: 0,
                                                right: 0,
                                                backgroundColor: "red",
                                                color: "#fff",
                                                fontSize: "12px",
                                                borderRadius: "50%",
                                                width: "16px",
                                                height: "16px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            {unreadAlerts}
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                border: "2px solid #1877F2",
                                borderRadius: "20px",
                                p: 1,
                                mb: 6,
                                display: "flex",
                                alignItems: "flex-start",
                                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                            }}
                        >
                            <img
                                src="/images/catppuccin_coffeescript.svg"
                                alt="bulb"
                                style={{width: "30px", heihgt: "30px", marginRight: 8, marginTop: 4}}
                            />
                            <img
                                src="/images/yellow-bulb-icon.svg"
                                alt="bulb"
                                style={{width: "30px", heihgt: "30px", marginRight: 8, marginTop: 4}}
                            />
                            <Box sx={{width: "100%", display: "flex", flexDirection: "column", alignItems: "center"}}>
                                <Typography fontSize={15} sx={{textAlign: "center"}}>
                                    Stop Guessing, Start Profiting. <strong>For just $1/month</strong>, unlock exclusive
                                    access to <strong>VALIDATED index</strong>, <strong>institutional</strong>, and{" "}
                                    <strong>influencer strategies</strong>.<br></br>Plus, highly efficient{" "}
                                    <strong>machine learning signals</strong> to catch trends early.
                                </Typography>
                            </Box>
                        </Box>

                        <Box textAlign="center" mb={6}>
                            <Button
                                onClick={() => onSelectAmount("price_1QV4J8KAXtGoEI6mJntRzF1L")}
                                sx={{
                                    background:
                                        "linear-gradient(91deg, rgba(154, 255, 249, 0.40) 18.86%, rgba(255, 240, 109, 0.40) 100.02%)",
                                    borderRadius: "50px",
                                    px: 4,
                                    py: 1,
                                    fontWeight: 700,
                                    fontSize: "16px",
                                    color: "#1877F2",
                                    textTransform: "none",
                                    boxShadow:
                                        "0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                    border: "2px solid #1877F2",
                                    width: "60%",
                                }}
                            >
                                BUY THE PLAN NOW @ $1/MONTH
                            </Button>
                        </Box>

                        <Box>
                            {/* Header */}
                            <Box
                                sx={{
                                    width: "100%",
                                    border: "1px solid #1877F2",
                                    borderRadius: "50px",
                                    background:
                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.20) -1.89%, rgba(24, 119, 242, 0.00) 60.38%)",
                                    padding: "10px 20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontWeight: 700,
                                    fontSize: "18px",
                                    color: "#000",
                                    mb: 4,
                                    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                }}
                            >
                                <img
                                    src="/images/green-steps.svg"
                                    alt="target"
                                    style={{width: "22.5px", height: "22.5px", marginRight: "8px"}}
                                />{" "}
                                WHAT DO YOU GET?????
                            </Box>

                            {/* Rows */}
                            {features.map((item, index) => (
                                <Box
                                    key={index}
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="flex-start"
                                    mb={
                                        index === 1
                                            ? 9
                                            : index === 2
                                            ? 18 // 3rd box (index 2)
                                            : index === 3
                                            ? 12
                                            : 7 // 4th box (index 3)
                                    }
                                    ml={10}
                                    mr={10}
                                >
                                    {/* Left Title Box */}
                                    <Box
                                        sx={{
                                            border: "2px solid #1877F2",
                                            borderRadius: "20px",
                                            padding: "12px 20px",
                                            background:
                                                "linear-gradient(180deg, rgba(24, 119, 242, 0.40) -1.89%, rgba(24, 119, 242, 0.00) 60.38%)",
                                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                            fontWeight: "700",
                                            color: "#000",
                                            display: "flex",
                                            width: "350px",
                                            height: "50px",
                                            fontSize: "16px",
                                            alignItems: "center",
                                            transform: "translateY(100%)",
                                            lineHeight: "1",
                                            whiteSpace: "pre-line",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            const link = getLinkFromTitle(item.title);

                                            if (!link) return;

                                            if (typeof link === "string") {
                                                navigate(link);
                                            } else if (typeof link === "object" && link.path) {
                                                navigate(link.path, {state: link.state});
                                            }
                                        }}
                                    >
                                        <img
                                            src="/images/red-arrow-point.svg"
                                            alt="target"
                                            style={{width: "35px", height: "35px", marginRight: "7%"}}
                                        />
                                        {item.title}
                                    </Box>

                                    {/* Right Description Box */}
                                    <Box
                                        sx={{
                                            border: "2px solid #1877F2",
                                            borderRadius: "20px",
                                            background: "#fff",
                                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                            width: "40%",
                                            height: index == 3 ? "25%" : "320px", // Increased height to fit larger text
                                            ml: 2,
                                            px: 2,
                                            py: 3,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            overflow: "hidden", // Keep content inside
                                            boxSizing: "border-box",
                                        }}
                                    >
                                        {item.points.map((point, idx) => (
                                            <Box
                                                key={idx}
                                                display="flex"
                                                alignItems="flex-start"
                                                justifyContent="center"
                                                mb={idx !== item.points.length - 1 ? 5 : 0}
                                                width="100%"
                                            >
                                                <img
                                                    src="/images/yellow-bulb-icon.svg"
                                                    alt="idea"
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        marginTop: "4px",
                                                        marginRight: "10px",
                                                        flexShrink: 0,
                                                    }}
                                                />
                                                <Box sx={{width: "100%", textAlign: "left"}}>
                                                    <Typography
                                                        fontSize="16px"
                                                        fontWeight="700"
                                                        color="#000"
                                                        lineHeight="1.4"
                                                        whiteSpace="pre-line"
                                                    >
                                                        {point}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            ))}
                            <Box textAlign="center" mb={6}>
                                <Button
                                    onClick={() => onSelectAmount("price_1QV4J8KAXtGoEI6mJntRzF1L")}
                                    sx={{
                                        background:
                                            "linear-gradient(91deg, rgba(154, 255, 249, 0.40) 18.86%, rgba(255, 240, 109, 0.40) 100.02%)",
                                        borderRadius: "50px",
                                        px: 4,
                                        py: 1,
                                        fontWeight: 700,
                                        fontSize: "16px",
                                        color: "#1877F2",
                                        textTransform: "none",
                                        boxShadow:
                                            "0px 4px 6px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                        border: "2px solid #1877F2",
                                        width: "60%",
                                    }}
                                >
                                    BUY THE PLAN NOW @ $1/MONTH
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </div>
            )}
            {open && <WalletPayment onClose={handleClose} open={open} />}

            {mediaQueryVar == false && (
                <div className="content" style={{marginTop: "100px"}}>
                    {/* Top Section: Tabs + My Profile Button + Notification */}
                    <Box sx={{marginTop: "2%"}}>
                        {/* <Box
    sx={{
        backgroundColor: "#1877F2",
        p: "4px",
        borderRadius: "50px",
        width: "100%",
        height:"48px",
        display: "flex",
        justifyContent: "center",
        marginTop: "15vw",
        marginBottom: "20vw",
    }}
>
<Tabs
    value={selectedTab}
    onChange={(e, newValue) => {
      if (newValue === "Predictions") {
        navigate("/indices");
      }
      setSelectedTab(newValue);
    }}
    variant="fullWidth"
    sx={{
      width: "100%",
      minHeight: "40px",
      "& .MuiTabs-flexContainer": {
        gap: "4px", // Use spacing here instead of mx on Tabs
      },
      "& .MuiTabs-indicator": { display: "none" },
    }}
  >
    {[
      { label: "CW360 Indices", value: "Portfolios" },
      { label: "Institution Indices", value: "Predictions" },
      
    ].map((tab) => (
      <Tab
  key={tab.value}
//   icon={
//     <Box
//   component="img"
//   src={
//     tab.value === "Portfolios"
//       ? "/images/home-new.svg"
//       : tab.value === "Invest"
//       ? "/images/money-new.svg"
//       : "/images/search-new.svg"
//   }
//   alt={tab.label}
//   sx={{ width: tab.value === "Predictions" ? "20.868px":"30px", height: tab.value === "Predictions" ? "20.872px":"30px" }}
// />

  // }
  iconPosition="start"
  label={tab.label}
  value={tab.value}
  sx={{
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    backgroundColor: selectedTab === tab.value ? "#fff" : "transparent",
    color: selectedTab === tab.value ? "#000 !important" : "#fff",
    borderRadius: "50px",
    px: 2,
    py: 0.3,
    mx: "2px",
    lineHeight: "36px",
    fontSize: selectedTab === tab.value ? "17px" : "16px",
    fontWeight: 400,
    minHeight: "36px",
    minWidth: "fit-content",
    textTransform: "none",
  }}
  
  
/>

    ))}
  </Tabs>
</Box> */}

                        <Box
                            sx={{
                                border: "2px solid #1877F2",
                                borderRadius: "20px",
                                px: mediaQueryVar2 ? 1 : 2,
                                py: 1,
                                ml: 1.5,
                                mr: 1.5,
                                mb: 3.5,
                                mt: 7,
                                height: mediaQueryVar2 ? "165px" : "140px",
                                display: "flex",
                                alignItems: "flex-start",
                                position: "relative",
                                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                            }}
                        >
                            <Box sx={{position: "absolute", top: 10, left: 10}}>
                                <img
                                    src="/images/yellow-coins.svg"
                                    alt="coins"
                                    style={{width: "28px", height: "28px"}}
                                />
                            </Box>
                            <Box sx={{width: "100%", textAlign: "center", mt: mediaQueryVar2 ? 3 : 1.5}}>
                                <Typography fontSize={14}>
                                    Stop Guessing, Start Profiting<br></br>
                                    <strong>For just $1/month</strong>, unlock exclusive access to{" "}
                                    <strong>VALIDATED index</strong>, <strong>institutional</strong>, and{" "}
                                    <strong>influencer strategies</strong>. Plus, highly efficient{" "}
                                    <strong>machine learning signals</strong> to catch trends early.
                                </Typography>
                            </Box>
                        </Box>

                        <Box textAlign="center" mb={5}>
                            <Button
                                onClick={() => onSelectAmount("price_1QV4J8KAXtGoEI6mJntRzF1L")}
                                sx={{
                                    background:
                                        "linear-gradient(91deg, rgba(154, 255, 249, 0.40) 18.86%, rgba(255, 240, 109, 0.40) 100.02%)",
                                    borderRadius: "50px",
                                    padding: "11px 4px 11px 4px",
                                    fontWeight: 700,
                                    fontSize: "16px",
                                    color: "#1877F2",
                                    textTransform: "none",
                                    boxShadow:
                                        "0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                    border: "2px solid #1877F2",
                                    width: "94%",
                                }}
                            >
                                BUY THE PLAN NOW @ $1/MONTH
                            </Button>
                        </Box>

                        <Box>
                            {/* Header */}
                            <Box
                                sx={{
                                    width: "95%",
                                    ml: 1.2,
                                    border: "1px solid #1877F2",
                                    borderRadius: "50px",
                                    background:
                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.20) -1.89%, rgba(24, 119, 242, 0.00) 60.38%)",
                                    padding: "10px 20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontWeight: 700,
                                    fontSize: "18px",
                                    color: "#000",
                                    mb: 4.5,
                                    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                    position: "relative",
                                }}
                            >
                                <Box sx={{position: "absolute", left: 20}}>
                                    <img
                                        src="/images/green-steps.svg"
                                        alt="target"
                                        style={{width: "30px", height: "30px"}}
                                    />
                                </Box>
                                <Box sx={{width: "100%", textAlign: "center"}}>WHAT DO YOU GET?????</Box>
                            </Box>

                            {/* Rows */}
                            {featuresMobile.map((item, index) => (
                                <Box
                                    key={index}
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                    mb={index === 0 ? 10 : index === 1 ? 9 : index === 2 ? 8 : 12}
                                    ml={1.5}
                                    mr={1.5}
                                >
                                    {/* Top Title Box */}
                                    <Box
                                        sx={{
                                            border: "2px solid #1877F2",
                                            borderRadius: "20px",
                                            padding: "12px 20px",
                                            background:
                                                "linear-gradient(180deg, rgba(24, 119, 242, 0.40) -1.89%, rgba(24, 119, 242, 0.00) 60.38%)",
                                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                            fontWeight: "700",
                                            color: "#000",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                            fontSize: "16px",
                                            width: "100%",
                                            height: "60px",
                                            lineHeight: "1.2",
                                            textAlign: "left",
                                            whiteSpace: "normal",
                                            mb: index === 2 ? 3 : index === 3 ? 7 : 5,
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            const link = getLinkFromTitle(item.title);

                                            if (!link) return;

                                            if (typeof link === "string") {
                                                navigate(link);
                                            } else if (typeof link === "object" && link.path) {
                                                navigate(link.path, {state: link.state});
                                            }
                                        }}
                                    >
                                        <img
                                            src="/images/red-arrow-point.svg"
                                            alt="target"
                                            style={{
                                                width: "30px",
                                                height: "30px",
                                                marginRight: mediaQueryVar2 && index == 3 ? "10px" : "50px",
                                            }}
                                        />
                                        {item.title}
                                    </Box>

                                    {/* Bottom Description Box */}
                                    <Box
                                        sx={{
                                            border: "2px solid #1877F2",
                                            borderRadius: "20px",
                                            background: "#fff",
                                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                            width: "98%",
                                            height: "273px",
                                            px: 2,
                                            py: 3,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center", // ✅ Center vertically
                                            boxSizing: "border-box",
                                        }}
                                    >
                                        {item.points.map((point, idx) => (
                                            <Box
                                                key={idx}
                                                display="flex"
                                                alignItems="flex-start"
                                                justifyContent="center"
                                                mb={
                                                    idx !== item.points.length - 1
                                                        ? index == 0
                                                            ? 6
                                                            : index === 2
                                                            ? 3.5
                                                            : index === 3
                                                            ? 6
                                                            : 2.5
                                                        : 0
                                                }
                                                width="100%"
                                            >
                                                <img
                                                    src="/images/yellow-bulb-icon.svg"
                                                    alt="idea"
                                                    style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        marginTop: "4px",
                                                        marginRight: "10px",
                                                        flexShrink: 0,
                                                    }}
                                                />
                                                <Typography
                                                    fontSize="16px"
                                                    fontWeight="700"
                                                    color="#000"
                                                    lineHeight="1.4"
                                                    textAlign="left"
                                                    whiteSpace="normal"
                                                >
                                                    {point}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            ))}

                            <Box textAlign="center" mb={15}>
                                <Button
                                    onClick={() => onSelectAmount("price_1QV4J8KAXtGoEI6mJntRzF1L")}
                                    sx={{
                                        background:
                                            "linear-gradient(91deg, rgba(154, 255, 249, 0.40) 18.86%, rgba(255, 240, 109, 0.40) 100.02%)",
                                        borderRadius: "50px",
                                        padding: "11px 4px 11px 4px",
                                        fontWeight: 700,
                                        fontSize: "16px",
                                        color: "#1877F2",
                                        textTransform: "none",
                                        boxShadow:
                                            "0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                        border: "2px solid #1877F2",
                                        width: "94%",
                                    }}
                                >
                                    BUY THE PLAN NOW @ $1/MONTH
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </div>
            )}
            <div
                style={{
                    position: "fixed",
                    bottom: "0",
                    backgroundColor: "white",
                    width: "105%",
                    zIndex: "100",
                    marginBottom: "0px",
                }}
                className="mobile-view"
            >
                <BottomNavigation showLabels>
                    <BottomNavigationAction
                        label="Top Portfolios"
                        onClick={() => navigate("/portfolio-gallery")}
                        icon={
                            <img
                                src={loc === "/portfolio-gallery" ? "/images/dashboardS.svg" : "/images/dashboardU.svg"}
                            />
                        }
                    />
                    <BottomNavigationAction
                        label="My Portfolios"
                        onClick={() => {
                            navigate(userData ? "/my-portfolio" : "/audit-my-portfolio");
                        }}
                        icon={
                            <img src={loc === "/my-portfolio" ? "/images/portfolioS.svg" : "/images/portfolioU.svg"} />
                        }
                    />
                    <BottomNavigationAction
                        label="Crypto Screener"
                        onClick={() => {
                            navigate("/crypto-screener");
                        }}
                        icon={
                            <img
                                src={loc === "/subscriptions" ? "/images/dollarS.svg" : "/images/dollarU.svg"}
                                width={24}
                                height={24}
                                alt="Icon"
                                style={{marginBottom: "-3px"}}
                            />
                        }
                    />
                </BottomNavigation>
            </div>
            {isLoginModalOpen && !isLoggedIn && (
                <LoginPopUp
                    isLoginModalOpen={isLoginModalOpen}
                    setLoginModalOpen={setLoginModalOpen}
                    onClose={handleModalClose}
                />
            )}
            <GoogleLoginHandler redirectUrl={location.pathname} />
        </div>
    );
};

export default Subscription;
